<template>
  <div class="nvr-player">
    <div ref="stage" class="nvr-player__stage"></div>
    <div v-if="loading && !error" class="nvr-player__mask">
      <i class="el-icon-loading"></i>
      <span>加载中…</span>
    </div>
    <div v-if="error" class="nvr-player__mask nvr-player__mask--error">
      <i class="el-icon-warning-outline"></i>
      <span>{{ error }}</span>
      <el-button size="mini" type="primary" @click="start">重试</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NvrPlayer',
  props: {
    url: { type: String, required: true },
    decoder: { type: String, default: '/jessibuca/decoder.js' }
  },
  data() {
    return {
      loading: true,
      error: ''
    }
  },
  watch: {
    url() {
      this.stop()
      this.$nextTick(this.start)
    }
  },
  mounted() {
    this.start()
  },
  beforeDestroy() {
    this.stop()
  },
  methods: {
    start() {
      this.stop()
      if (!window.Jessibuca) {
        this.error = '播放器脚本未加载'
        this.loading = false
        return
      }
      this.error = ''
      this.loading = true
      this._player = new window.Jessibuca({
        container: this.$refs.stage,
        decoder: this.decoder,
        videoBuffer: 0.2,
        isResize: true,
        hasAudio: false,
        isNotMute: false,
        useWCS: false,
        useMSE: false,
        forceNoOffscreen: true,
        loadingText: '',
        timeout: 20
      })
      this._player.on('videoInfo', () => { this.loading = false })
      this._player.on('play', () => { this.loading = false })
      this._player.on('error', (err) => {
        this.error = '播放失败：' + (err && err.message ? err.message : String(err))
        this.loading = false
      })
      this._player.play(this.url)
      this._loadingTimer = setTimeout(() => { this.loading = false }, 15000)
    },
    stop() {
      if (this._loadingTimer) {
        clearTimeout(this._loadingTimer)
        this._loadingTimer = null
      }
      if (this._player) {
        try { this._player.destroy() } catch (e) { this._player = null }
        this._player = null
      }
    }
  }
}
</script>

<style scoped>
.nvr-player {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  overflow: hidden;
}
.nvr-player__stage {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
/* 让解码画布填满单元格（减少上下/左右黑边） */
.nvr-player__stage ::v-deep canvas {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  transform: none !important;
  width: 100% !important;
  height: 100% !important;
  display: block;
}
.nvr-player__mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #cbd5e1;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.6);
}
.nvr-player__mask--error {
  color: #fca5a5;
}
.nvr-player__mask i {
  font-size: 26px;
}
</style>
